import { ApisauceConfig } from 'apisauce';
import { Observable } from 'rxjs';
import { SpreedlyRecacheRequest } from '~client/model/spreedly-recache-request';
import { SpreedlyRequest } from '~client/model/spreedly-request';
import { SpreedlyResponse } from '~client/model/spreedly-response';
import { SimpleClient } from '~client/simple-client';

/*
 * Docs: https://docs.spreedly.com/reference/api/v1/
 */
export class SpreedlyClient extends SimpleClient {
  private environmentKey: string;

  constructor(environmentKey: string, config?: ApisauceConfig) {
    super(config);

    this.environmentKey = environmentKey;
  }

  /* Return a token for a given credit card. */
  public createPaymentMethod$(request: SpreedlyRequest): Observable<SpreedlyResponse> {
    return this.post$(`/v1/payment_methods.json?environment_key=${this.environmentKey}`, request);
  }

  /* Update a credit card’s verification value (CVV) so the card can be transacted against. */
  public recachePaymentMethod$(
    externalPaymentMethodId: string,
    request: SpreedlyRecacheRequest,
  ): Observable<SpreedlyResponse> {
    return this.post$(
      `/v1/payment_methods/${externalPaymentMethodId}/recache.json?environment_key=${this.environmentKey}`,
      request,
    );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/client/spreedly-client.ts